$(function () {
	const cards = document.querySelectorAll('.card.effect__random');
	const timeMin = 1;
	const timeMax = 30;
	const timeouts = [];

	// loop through cards
	for (let i = 0, len = cards.length; i < len; i++) {
		const card = cards[i];
		const cardID = card.getAttribute('id');
		const id = `timeoutID${cardID}`;
		const time = randomNum(timeMin, timeMax) * 1000;
		cardsTimeout(id, time, card);
	}

	// timeout listener
	function cardsTimeout(id, time, card) {
		if (id in timeouts) {
			clearTimeout(timeouts[id]);
		}
		timeouts[id] = setTimeout(function () {
			const c = card.classList;
			const newTime = randomNum(timeMin, timeMax) * 1000;
			c.contains('flipped') === true ? c.remove('flipped') : c.add('flipped');
			cardsTimeout(id, newTime, card);
		}, time);
	}

	// random number generator given min and max
	function randomNum(min, max) {
		return Math.random() * (max - min) + min;
	}
});
